import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_widget_theme_link_RowClass} from '../../../dbschema';


export class WidgetThemeLinkContainerModel extends BaseContainerModel {
  bl_cms_widget_theme_link: bl_cms_widget_theme_link_RowClass = new bl_cms_widget_theme_link_RowClass();
}
